import {
  Box,
  ButtonLink,
  Column,
  Columns,
  ContentBlock,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import queryString from 'query-string';
import React, { Fragment } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import Header from 'src/components/Header/Header';

const RecommendationUnsubscribe = () => {
  const { id } = useParams();
  const urlLocation = useLocation();
  const { token } = queryString.parseUrl(urlLocation.search).query;
  return (
    <Fragment>
      <Header title="Buying a business" />
      <ContentBlock>
        <Box paddingX={['medium', 'none']} paddingY="xlarge">
          <Stack space="large">
            <Heading level="2">Before you go!</Heading>
            <Text>
              Did you know you can manage your preferences? You can now manage
              the type of business recommendations we email you. This way
              you&apos;ll only receive businesses that match your criteria (that
              is, businesses that you&apos;ll actually be interested in!).
            </Text>
            <Columns collapseBelow="tablet" space="medium">
              <Column width="1/3">
                <ButtonLink href={`/buyer/preferences?token=${token}`}>
                  Manage my preferences
                </ButtonLink>
              </Column>
              <Column width="1/3">
                <ButtonLink variant="ghost" href={`/unsubscribe/${id}`}>
                  No thanks, unsubscribe me
                </ButtonLink>
              </Column>
            </Columns>
          </Stack>
        </Box>
      </ContentBlock>
    </Fragment>
  );
};

export default RecommendationUnsubscribe;
